import React from 'react';
import {DailyWeek, ManagementOverviewResponse, StationOverview} from '../types/ManagementOverviewReport.types';
import ReportHeader from './ReportHeader';
import ReportFooter from './ReportFooter';
import ReportCharts from './ReportCharts';
import DailyResultsTable from './DailyResultsTable';
import ReportSectionTitle from './ReportSectionTitle';

interface ManagementOverviewPageTwoProps {
    report: ManagementOverviewResponse;
    station: StationOverview;
    dailyWeeks: DailyWeek[];
    onChartReady?: (chartId: string) => void;
    includeCharts?: boolean;
    dailyPageIndex: number;
}

const ManagementOverviewPageTwo: React.FC<ManagementOverviewPageTwoProps> = ({
    report,
    station,
    dailyWeeks,
    onChartReady,
    includeCharts = true,
    dailyPageIndex,
}) => {
    return (
        <article
            className="report-page management-overview-page"
            data-page-kind="daily"
            data-station-id={station.stationId}
            data-daily-page-index={dailyPageIndex}
        >
            <ReportHeader
                customerName={report.customerName}
                referencePeriod={report.referencePeriod}
                generatedOn={report.generatedOn}
                stationName={station.stationName}
                showFullTitle={false}
            />

            <div className="report-page__body">
                {includeCharts && (
                    <ReportCharts
                        page="two"
                        stationId={station.stationId}
                        charts={station.charts}
                        referencePeriod={report.referencePeriod}
                        onChartReady={onChartReady}
                    />
                )}

                <section className="management-overview-daily-section">
                    <ReportSectionTitle>Resultados Diários</ReportSectionTitle>
                    <DailyResultsTable weeks={dailyWeeks} />
                </section>
            </div>

            <ReportFooter customerName={report.customerName} generatedOn={report.generatedOn} />
        </article>
    );
};

export default ManagementOverviewPageTwo;
